import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import VPNShowcase from './components/VPNShowcase';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <VPNShowcase />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
}
